import React from 'react';
import { motion } from 'framer-motion';
import useAnimation from '_helpers/hooks/useAnimation';
import ANIMATION_DURATION from 'constants/common/animation-duration';
import { useNavigate } from 'react-router-dom';
import { useSwipeable } from 'react-swipeable';
import determineAnimation from '_helpers/generic/Animations';

export default function index({ children }: any) {
  const { ANIMATIONS } = useAnimation();
  const { previousPage, nextPage, setAnimation, setCurrentPageIndex, currentPageIndex } = useAnimation();
  const navigate = useNavigate();

  const handlers = useSwipeable({
    onSwipedDown: () => {
      if (previousPage?.path) {
        setAnimation(determineAnimation(previousPage?.path));
        setCurrentPageIndex(previousValue => previousValue - 1);
        navigate(previousPage?.path);
      }
    },
    onSwipedUp: () => {
      if (nextPage?.path) {
        setAnimation(determineAnimation(nextPage?.path));
        setCurrentPageIndex(previousValue => previousValue + 1);
        navigate(nextPage?.path);
      }
    },
    trackMouse: true,
    delta: 150,
  });

  return (
    <motion.div
      {...handlers}
      className="h-full w-full flex flex-col justify-center relative"
      variants={ANIMATIONS}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: ANIMATION_DURATION }}>
      {children}
    </motion.div>
  );
}
